import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SaleSampleService } from "../../../services/salesample.service";
declare var google;

@Component({
  selector: "inwardList",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./inwardList.html",
})
export class SampleInwardComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    fin_year: "",
    party_id: "",
    shirt_designno: "",
    invno: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  invList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("invoiceTemplate") invoiceTemplate: TemplateRef<any>;
  @ViewChild("detailsTemplate") detailsTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("finAuto") finAuto;
  @ViewChild("partyAuto") partyAuto;

  finCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  invCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  sampleList: any = [];
  totpcs: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesampservice: SaleSampleService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "No",
        prop: "sm_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Date",
        prop: "sm_date_formatted",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Party Name",
        prop: "name",
        headerClass: "text-center",
        cellClass: "text-left",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
      },
      {
        name: "Phone No",
        prop: "phone",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Type",
        prop: "sample_type",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        cellClass: "text-center",
        width: 80,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#invno").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.InwardList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.fin_year = "";
    this.filter.party_id = "";
    this.filter.shirt_designno = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.InwardList();
  }

  addEditEntry(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.InwardList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (this.menu.sale_type == "IN") {
      if (mode == "Add") {
        tabObj = {
          action: "NewTab",
          params: {
            //  tabParent: 'Transaction',
            tabName: "INWARD ENTRY",
            title: "INWARD ENTRY",
            tabParent: "MASTER",
            mode: mode,
            data: row,
            name: "INWARD ENTRY",
            sale_type: this.menu.sale_type,
          },
        };
      } else {
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "INWARD ENTRY",
            title: "INWARD ENTRY",
            tabParent: "MASTER",
            mode: mode,
            data: row,
            name: "INWARD ENTRY",
            sale_type: this.menu.sale_type,
          },
        };
      }
    } else if (this.menu.sale_type == "OUT") {
      if (mode == "Add") {
        tabObj = {
          action: "NewTab",
          params: {
            //  tabParent: 'Transaction',
            tabName: "OUTWARD ENTRY",
            title: "OUTWARD ENTRY",
            tabParent: "MASTER",
            mode: mode,
            data: row,
            name: "OUTWARD ENTRY",
            sale_type: this.menu.sale_type,
          },
        };
      } else {
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "OUTWARD ENTRY",
            title: "OUTWARD ENTRY",
            tabParent: "MASTER",
            mode: mode,
            data: row,
            name: "OUTWARD ENTRY",
            sale_type: this.menu.sale_type,
          },
        };
      }
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  InwardList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      sm_type: this.menu.sale_type,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    that.isLoadMask = that.salesampservice
      .getSampleList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.sampleList = res.data;
        for (let i = 0; i < that.sampleList.length; i++) {
          that.sampleList[i].sm_date_formatted = that.datePipe.transform(
            that.sampleList[i].sm_date,
            "dd-MM-yyyy"
          );
        }
      });
  }

  deleteEntry(row: any): void {
    let that = this;
    let params = {
      sm_id: row.sm_id,
    };
    swal({
      title: "Are you sure to delete this Entry?",
      text: "You will not be able to recover this details",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.salesampservice
          .delete(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.InwardList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/Inward/inwardList.ts